Lyte.Component.register("lyte-editor-toolbar", {
	data: function () {
		return {
			toolsInstance: Lyte.attr('object', { default: {} }),//No I18n
			toolbar: Lyte.attr('array'),
			tools: Lyte.attr('array'),
			tooltipConfig: Lyte.attr('string'),
			currentToolbarData: Lyte.attr('object'),//No I18n
			connectedEditor: Lyte.attr('object')//No I18n
		}
	},
	init: function () {
		this.setData('tooltipConfig', JSON.stringify({
			position: 'bottom',
			showdelay: 500,
			appearance: 'box',
			margin: 5,
			maxdisplaytime: 3000
		}));
	},
	/**
	 * This is done only when lyte-editor is used inside lyte-editor-layout tag
	 * So that application team can add divs to the right and left of the editor
	 * @param {Object} object Connection Object
	 */
	connectWith: function (object) {
		for (let key in object) {
			const node = object[key];
			switch (key) {
				case 'editor': {
					const data = node.getData();
					this.setData({
						connectedEditor: node,
						toolsInstance: data.toolsInstance,
						currentToolbarData: data.currentToolbarData,
						toolbar: data.providedToolbarData
					});
				}
			}
		}
	},
	/**
	 * Overrides tools in the runtime
	 */
	overrideTools: function () {
		const toolsInstance = this.data.toolsInstance;
		const tools = _led.overrideTools(this.data.toolbar, this.data.currentToolbarData, toolsInstance);
		this.setData('tools', tools);//No I18n
	},
	removeCustomToolsInstance : function(){
		// Flow : remove custom elements using custom boolean;

			const toolsInstance = this.data.toolsInstance;
			const newInstObj = {};
			for(let eachToolInstanceKey in toolsInstance){
				const eachToolInstance = toolsInstance[eachToolInstanceKey];
				const custom = eachToolInstance.custom;
				if(!custom){
					newInstObj[eachToolInstanceKey] = eachToolInstance;
				}
			}	
			this.setData("toolsInstance" , newInstObj);
	},
	/**
	 * Triggers event to the lyte-editor or lyte-editor-layout 
	 * tag based on the html given by the user
	 */
	triggerEventInEditor: function () {
		const connectedEditor = this.data.connectedEditor;
		const args = Array.from(arguments);
		if (connectedEditor) {
			connectedEditor.triggerAction.apply(connectedEditor.component, args.slice(1));
		} else {
			this.throwEvent.apply(this, args);
		}
	},
	toolsObserver: function (changeObj) {
		// Flow : if change is i toolbar 
		if (this.data.toolbar && this.data.currentToolbarData) {
			if(changeObj && changeObj.item=='toolbar'){
				const changeType = changeObj.type == "change";
					if(changeType){
						this.removeCustomToolsInstance();
						this.overrideTools();
					}
					else{
						this.overrideTools();
					}
			}
			else{
				this.overrideTools();
			}
		}
	}.observes('toolbar.[]', 'currentToolbarData').on('init'),//No I18n
	actions: {
		/**
		 * This will throw the event to the parent
		 * @param {Object} tool tool object
		 * @param {HTMLElement} node tool div node
		 * @param {Event} event 
		 */
		triggerAction: function (tool, node, event ,toolName) {
			const preventEventThrowFor = [
				// These events will be handled via methods
				//ignorei18n_start
				'fontSize',
				// 'toggleDarkMode'
				//ignorei18n_end
			]
			if (!preventEventThrowFor.includes(tool.triggerAction)) {
				if(tool.custom){
					const toolObj = {
						toolName
					}
					const avoidKeys = {"custom" : true , "preventHoverClass":true}
					Object.assign(toolObj , Object.keys(tool).reduce(function(acc, eachKey){
						const val = tool[eachKey];
						if(!avoidKeys[eachKey]){
							acc[eachKey] = val;
						}
						return acc;
					}, {}))
					this.executeMethod('onEditorToolIconClick' ,toolObj);
				}
				else{
					if( tool.triggerAction === "theme" ){
						if( tool.current && ( tool.current === "vs-dark" || tool.current === true )){
							tool.current = _led.LIGHT_THEME;
						}else{
							tool.current = _led.DARK_THEME
						}
					}
					this.triggerEventInEditor('triggerEditorAction', tool.triggerAction, tool.current, tool, node, event);//No I18n
				}
				
			}
		}
	},
	methods: {
		alterFontSize: function (tool, node, event, selectedValue) {
			this.triggerEventInEditor('triggerEditorAction', 'fontSize', selectedValue, tool, node, event);//No I18n
		},
		changeMode: function (tool, node, input, checkbox, event) {
			const theme = input.checked ? _led.DARK_THEME : _led.LIGHT_THEME;
			this.triggerEventInEditor('triggerEditorAction', 'theme', theme, tool, node, event);//No I18n
		}
	},
	utils: function () {
		const utils = {
			getInfoOfTool: function (toolName) {
				const tools = this.data.tools;
				for( let i = 0; i < tools.length; i++ ){
					if( tools[i].name === toolName ){
						return tools[i];
					}
				}
				return null;
			}
		}
		for (let util in utils) {
			if (_led.checkType.function(utils[util])) {
				this.$node[util] = utils[util].bind(this);
			} else {
				this.$node[util] = utils[util];
			}
		}
		this.disposeUtils = function () {
			for (let util in utils) {
				delete this.$node[util];
			}
		}
	}.on('init')
});